export class QuestionBase<T> {
  value: T|undefined;
  key: string;
  label: string;
  required: number;
  email: number;
  order: number;
  row: number;
  column: number;
  ptctNo: string;
  type: string;
  placeholder: string;
  options: {key: string, value: any}[];
  unit: string;
  format: string;
  attachments: any[] = [];

  constructor(options: {
      value?: T;
      key?: string;
      label?: string;
      required?: any;
      email?: number,
      order?: number;
      ptctNo?: string; // 控件类型
      type?: string;
      row?: number;
      column?: number;
      placeholder?: string;
      options?: {key: string, value: string}[];
      unit?: string;
      format?: string;
      attachments?: any[];
    } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = options.email === undefined ? 0 : options.required;
    this.email = options.email === undefined ? 0 : options.email;
    this.order = options.order === undefined ? 1 : options.order;
    this.row = options.row === undefined ? 1 : options.row;
    this.column = options.column === undefined ? 1 : options.column;
    this.ptctNo = options.ptctNo || '';
    this.type = options.type || '';
    this.placeholder = options.placeholder || '';
    this.options = options.options || [];
    this.unit = options.unit || '';
    this.format = options.format || '';
    this.attachments = options.attachments || [];
  }
}
